export const DEFAULT_COUNTRY_FLAG_EMOJI = '🌍';

const REGIONAL_INDICATOR_A = 0x1f1e6;
const ASCII_A = 0x41;

const ALPHA2_ALIASES: Record<string, string> = {
  UK: 'GB'
};

function normalizeAlpha2(raw: string): string | null {
  const upper = raw.trim().toUpperCase();
  if (upper.length !== 2 || !/^[A-Z]{2}$/.test(upper)) {
    return null;
  }
  return ALPHA2_ALIASES[upper] ?? upper;
}

function alpha2ToRegionalIndicatorEmoji(alpha2: string): string {
  return String.fromCodePoint(
    REGIONAL_INDICATOR_A + (alpha2.charCodeAt(0) - ASCII_A),
    REGIONAL_INDICATOR_A + (alpha2.charCodeAt(1) - ASCII_A)
  );
}

/**
 * ISO 3166-1 alpha-2 국가 코드(예: KR, US)를 국기 이모지로 변환합니다.
 * 빈 값·잘못된 코드·2글자가 아닌 경우 {@link DEFAULT_COUNTRY_FLAG_EMOJI}를 반환합니다.
 */
export function getCountryFlagEmoji(country?: string | null): string {
  if (country == null || country === '') {
    return DEFAULT_COUNTRY_FLAG_EMOJI;
  }
  const alpha2 = normalizeAlpha2(country);
  if (!alpha2) {
    return DEFAULT_COUNTRY_FLAG_EMOJI;
  }
  return alpha2ToRegionalIndicatorEmoji(alpha2);
}
